import { IError } from '@checkout/errors';
import { IAddVoucherSuccessPayload, IRemoveVoucherSuccessPayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic, ofType } from 'redux-observable';
import 'rxjs/add/observable/concat';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { catchError, delay, flatMap, mergeMap, mergeMapTo, tap } from 'rxjs/operators';
import { logger } from '../utils/logger';
import { kcoResume, kcoSuspend } from '../utils/widgets';
import ActionTypes from './../actions/actionTypes';
import { AddVoucherRequestAction, RemoveVoucherRequestAction } from './../actions/actionTypes.d';
import { RootAction } from './../actions/actionTypes.d';
import { addVoucherError, addVoucherSuccess, clearVoucherError, removeVoucherSuccess, setErrors } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';
import { createExpireDate } from './../utils/utils';

let numberLimit = 0;

export const addVoucherEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$.pipe(
    ofType(ActionTypes.ADD_VOUCHER_REQUEST),
    tap(() => { kcoSuspend(); }),
    mergeMap((action: AddVoucherRequestAction) => {
      return fromPromise$(rest.httpPost('/vouchers', { voucher: action.payload }))
        .pipe(
          flatMap((payload: AxiosResponse<IAddVoucherSuccessPayload>) => {
            kcoResume();
            numberLimit = 0;
            return of$(addVoucherSuccess(payload.data));
          }),
          catchError((error: IError) => {
            numberLimit = numberLimit + 1;
            const expireSpan = 5 * 60 * 1000; /* 5 minutes in ms */
            let expireDate = undefined;

            if (numberLimit >= 5) {
              expireDate = createExpireDate(expireSpan);
              numberLimit = 0;
            }

            kcoResume();
            logger(error);
            if (error.response && error.response.data) {
              return of$(addVoucherError({ error: error.response.data.errors.voucher, expireDate }));
            }
            return of$(setErrors(error));
          })
        );
    })
  );

export const removeVoucherEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$.pipe(
    ofType(ActionTypes.REMOVE_VOUCHER_REQUEST),
    tap(() => { kcoSuspend(); }),
    mergeMap((action: RemoveVoucherRequestAction) => {
      return fromPromise$(rest.httpDelete('/vouchers', { voucher: action.payload }))
        .pipe(
          flatMap((payload: AxiosResponse<IRemoveVoucherSuccessPayload>) => {
            kcoResume();
            return of$(removeVoucherSuccess(payload.data));
          }),
          catchError((error: IError) => {
            kcoResume();
            logger(error);
            return of$(setErrors(error));
          })
        );
    })
  );

export const clearVoucherErrorsEpic: Epic<RootAction, RootAction, RootState> = (action$, state$) =>
  action$.pipe(
    ofType(ActionTypes.ADD_VOUCHER_ERROR),
    delay(5000),
    mergeMapTo(of$(clearVoucherError()))
  );
